// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2_B-K","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__1f3PM","gfeWrapper":"CalendarEvent_gfeWrapper__17D6J"};